export enum FormValueState {
    SET = 'set',
    UNSET = 'unset',
    INDETERMINATE = 'indeterminate'
}

export class FormValue<T = string> {
    readonly value: T;
    readonly state: FormValueState;

    constructor(value: T, state: FormValueState = FormValueState.SET) {
        this.value = value;
        this.state = value === null && state === FormValueState.SET ? FormValueState.UNSET : state;
    }

    static wrap<G>(obj: G): FormValue<G> {
        return new FormValue(obj);
    }

    static unwrap<G>(formValue: FormValue<G>): G {
        switch (formValue.state) {
            case FormValueState.INDETERMINATE:
                throw new Error('unwrapping FormValue:: indeterminate should not occur');
            case FormValueState.SET:
            case FormValueState.UNSET:
            default:
                return formValue.value;
        }
    }
}
